import { useCallback, useEffect, useState } from "react";
import { useAPI } from "../../../contexts/APIContext";
import learnAudio from "./learnAudio";

/**
 * Hook facade over the audio singleton. Drop-in for the old useLearnSpeech
 * signature ({ speak, replay, cancel }) plus sfx/prefetch/state.
 */
export function useLearnAudio() {
  const { apiClient } = useAPI();
  const [state, setState] = useState(learnAudio.state());

  useEffect(() => {
    learnAudio.configure({ apiClient });
  }, [apiClient]);

  useEffect(() => learnAudio.onChange(setState), []);

  const speak = useCallback((text, opts) => learnAudio.speak(text, opts), []);
  const replay = useCallback((text) => learnAudio.speak(text, { interrupt: true, dedupe: false }), []);
  const cancel = useCallback(() => learnAudio.cancel(), []);
  const sfx = useCallback((name, opts) => learnAudio.sfx(name, opts), []);
  const prefetch = useCallback((lines) => learnAudio.prefetch(lines), []);
  const unlock = useCallback(() => learnAudio.unlock(), []);

  return { speak, replay, cancel, sfx, prefetch, unlock, ...state };
}

export default useLearnAudio;
